import Vue from "vue";
import ElementUI from "element-ui";

import "element-ui/packages/theme-chalk/lib/index.css";

Vue.use(ElementUI);
